<template>
  <v-card outlined tile elevation="0" class="mt-6">
    <v-card-title>
      Aggiorna Dettagli Lavorazione
    </v-card-title>
    <v-card-text>
      <Form
        :disabled="editFormDisabled"
        hide-reset
        send-text="Aggiorna Ticket"
        @submit="onSubmit"
      >
        <v-alert v-if="!isAssignedToUser" type="info" prominent dense outlined>
          Prendi in carico il ticket per procedere
        </v-alert>
        <v-divider class="mb-6" />
        <v-row>
          <FormItem
            v-model="status"
            name="Stato Lavorazione"
            type="select"
            :values="statuses"
            rules="required"
            required
            :clearable="true"
            :cols="12"
            :sm="8"
            :md="6"
            :lg="6"
            :xl="6"
            @input="resolution = null"
          />
        </v-row>
        <v-row>
          <FormItem
            v-model="resolution"
            name="Esito Lavorazione"
            type="select"
            :values="resolutions"
            :rules="isStatusSuspend ? '' : 'required'"
            :required="!isStatusSuspend"
            :clearable="true"
            :cols="12"
            :sm="8"
            :md="6"
            :lg="6"
            :xl="6"
          />
        </v-row>
        <v-row>
          <FormItem
            v-model="customer_notes"
            name="Note Cliente"
            type="textarea"
            :cols="12"
            :sm="10"
            :md="8"
            :lg="8"
            :xl="8"
            :rows="5"
            required
          /> </v-row
        ><v-row>
          <FormItem
            v-model="operator_notes"
            name="Note Operatore"
            type="textarea"
            ::cols="12"
            :sm="10"
            :md="8"
            :lg="6"
            :xl="6"
            :rows="5"
            required
          />
        </v-row>
        <v-row v-if="currentTenantTicketDetail.show_priority === true" dense>
          <FormItem
            v-model="prioritary"
            name="Richiesta Prioritaria"
            type="switch"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          />
        </v-row>
        <v-row v-if="ticket.asset_id || isMagicLink">
          <FormItem
            v-model="partner_ticket_id"
            name="Ticket Partner Esterno"
            hint="Inserisci identificativo TT Partner"
            :rules="{ required: isMagicLink }"
            :cols="12"
            :sm="8"
            :md="5"
            :lg="4"
            :xl="4"
          />
          <FormItem
            v-if="ticket.asset_id"
            v-model="partner_ticket_tracking"
            name="Link Tracking Spedizione"
            hint="Inserisci qui il link al tracking spedizione, se disponibile"
            :cols="12"
            :sm="8"
            :md="6"
            :lg="6"
            :xl="6"
          />
        </v-row>
      </Form>
    </v-card-text>
  </v-card>
</template>

<script>
import Form from '@components/forms/Form.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import FormItem from '@components/forms/FormItem.vue'
import { createHelpers } from 'vuex-map-fields'
import { authComputed } from '@state/helpers.js'
import utils from '@mixins/utils.js'

const { mapFields } = createHelpers({
  getterType: 'tickets/getCurrent',
  mutationType: 'tickets/SET_CURRENT_FIELDS',
})

export default {
  name: 'TicketEditForm',
  components: { FormItem, Form },
  mixins: [utils],
  computed: {
    ...authComputed,
    ...mapState('tickets', {
      ticket: 'current',
    }),
    ...mapState('ticketsActivities', {
      activity: 'current',
    }),
    ...mapState('ticketsStatuses', {
      allStatuses: 'list',
    }),
    ...mapGetters('tickets', {
      isAssignedToUser: 'isAssignedToUser',
    }),
    ...mapGetters('ticketsStatuses', {
      statusesByContext: 'statusesByContext',
    }),
    ...mapGetters('ticketsResolutions', {
      resolutionsByContext: 'resolutionsByContext',
    }),
    ...mapFields([
      'customer_notes',
      'operator_notes',
      'prioritary',
      'status',
      'resolution',
      'activity.macro',
      'activity.category',
      'activity.subcategory',
      'date_appointment',
      'date_appointment_end',
      'partner_ticket_id',
      'partner_ticket_tracking',
    ]),

    statuses() {
      return this.statusesByContext({
        macro: this.activity.macro,
        category: this.activity.category,
      })
    },
    isStatusSuspend() {
      return this.allStatuses.find((s) => s.code === this.status)?.suspend === true
    },
    resolutions() {
      return this.resolutionsByContext({
        macro: this.activity.macro,
        category: this.activity.category,
        status: this.status,
      })
    },
    editFormDisabled() {
      return (
        !this.isAssignedToUser || !this.canUser('tickets', 'update')
        // || this.ticket.created_by !== this.beUsername
      )
    },
    isMagicLink() {
      return this.$route.params.magic_link
    }
  },
  watch: {
    status() {
      this.resolution = null
    },
  },
  methods: {
    ...mapActions('tickets', ['update']),
    async onSubmit() {
      try {
        await this.update()
      } catch (err) {
        console.debug(err)
      }
    },
  },
}
</script>

<style scoped></style>
